<template>
  <v-row class="mt-1" justify="center">
    <v-col cols="12" sm="8">
      <av-waveform v-if="srcURL"
        :canv-width="300"
        :canv-height="80"
        :played-line-color="graphColor"
        :noplayed-line-color="graphColor"
        :playtime-slider-color="graphColor"
        :playtime-font-color="graphColor"
        :audio-src="srcURL">
      </av-waveform>
    </v-col>
    <v-col cols="12" sm="4" :class="$vuetify.breakpoint.xsOnly ? 'd-flex justify-center align-center' : ''">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-2 mb-2"
            v-bind="attrs" v-on="on"
            @click="uploadShow=true">
            <v-icon class="mr-2">mdi-upload</v-icon>
            <span>{{ $t('announce.upload.btnUpload') }}</span>
          </v-btn>
        </template>
        <span>{{ $t('announce.ttip.upload') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-2 mb-2"
            @click="recShow=true"
            v-bind="attrs" v-on="on">
            <v-icon class="mr-2">mdi-microphone-settings</v-icon>
            <span>{{ $t('announce.recording') }}</span>
          </v-btn>
        </template>
        <span>{{ $t('announce.ttip.record') }}</span>
      </v-tooltip>
    </v-col>
    <Upload :show="uploadShow" @select-file="selectFile"
      @cancel="uploadShow=false"/>
    <Recorder
      :title="$t('announce.recording')"
      :show="recShow"
      @save-record="selectRecording($event)"
      @cancel="recShow=false"/>
  </v-row>
</template>

<script>
import Recorder from '@/components/recorder'
import Upload from './upload'
export default {
  name: 'announcements-recording',
  data () {
    return {
      recShow: false,
      srcURL: null,
      uploadShow: false,
      graphColor: '#2196f3'
    }
  },
  props: {
    src: {
      type: String
    }
  },
  components: { Upload, Recorder },
  mounted () {
    this.srcURL = this.src
  },
  computed: {
    canReset: function () {
      return this.srcURL !== this.src
    }
  },
  methods: {
    selectFile: function (val) {
      this.uploadShow = false
      this.updateURL(val)
    },
    selectRecording: function (val) {
      this.recShow = false
      this.updateURL(val)
    },
    updateURL: function (url) {
      this.srcURL = null
      this.$nextTick(() => {
        this.srcURL = URL.createObjectURL(url)
        this.$emit('update-src', this.srcURL)
      })
    }
  }
}
</script>

<style scoped>
</style>
